import React, { useRef } from "react";

import { OverlayPanel } from "primereact/overlaypanel";
import { T } from "services/lang/LanguageService";

const FilterInfoOverlay: React.FC = () => {
  const overlayRef = useRef<OverlayPanel>(null);

  return (
    <>
      <i
        className="pi pi-info-circle text-primary cursor-pointer pl-2"
        onClick={e => overlayRef.current?.toggle(e)}
      />
      <OverlayPanel ref={overlayRef}>
        <div className="flex flex-column gap-2" style={{ maxWidth: "22rem" }}>
          <strong>{T("word.filter-syntax")}</strong>
          <span>column_ref:OPERATOR:&quot;value&quot;</span>
          <span>
            <strong>{T("word.example")}:</strong> status:EQ:&quot;active&quot;
          </span>
          <span>
            <strong>AND:</strong> (col1:EQ:&quot;a&quot;);(col2:EQ:&quot;b&quot;)
          </span>
          <span>
            <strong>OR:</strong> (col1:EQ:&quot;a&quot;)|(col2:EQ:&quot;b&quot;)
          </span>
          <span>
            <strong>{T("word.operators")}:</strong> EQ, NE, GT, GTE, LT, LTE, CONTAINS, STARTS_WITH
          </span>
        </div>
      </OverlayPanel>
    </>
  );
};

export default FilterInfoOverlay;
